import * as React from 'react'
import { designTokens } from '../../lib/design-tokens'

type IconProps = React.SVGProps<SVGSVGElement> & {
  color?: string
  strokeWidth?: string | number
}

export const AlertTriangleIcon = ({
  width = 24,
  height = 24,
  color = designTokens.colors.semantic.error,
  strokeWidth = designTokens.borders.widths.alertIcon,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    focusable="false"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="12"
      y1="9"
      x2="12"
      y2="13"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
    <line
      x1="12"
      y1="17"
      x2="12"
      y2="17"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </svg>
)

AlertTriangleIcon.displayName = 'AlertTriangleIcon'
